import { BulkScope } from '../types';

export const getBulkLabel = (bulk: BulkScope): string =>
  bulk.kind === 'all' ? `All users · ${bulk.count}` : `Everyone in ${bulk.label} · ${bulk.count}`;

export const pluralize = (count: number, singular: string, plural = `${singular}s`): string =>
  `${count} ${count === 1 ? singular : plural}`;
